<!-- 最新动态 -->
<template>
  <div class="flex flex-col gap-4 mt-3">
    <!-- 标题 -->
    <div class="oneTitleDiv">
      <div class="oneTitle">
        <div class="pubTitle">
          <img :src="require('@/assets/title1.png')" alt="" width="22px" height="22px"/>
          <span style="margin-left: 8px;">最新动态</span>
        </div>
        <div class="pubTitles">
          <div style="width: 32px;height: 2px;background: #176DAA;margin-right: 10px"></div>
          News
        </div>
      </div>
      <div class="oneMore" @click="goMore">
        <img :src="require('@/assets/moreIconPro.png')" alt="" />
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="px-4 relative"
      @click="() => handleNavigateToDetail(exhibitionNews?.id,exhibitionNews?.title)"
    >
      <div class="w-full h-52">
        <img @error="handleImageError" class="w-full h-full" :src="exhibitionNews.picUrl?'/mainsys/UserFiles/menupic/' + exhibitionNews.picUrl:defaultImg" />
      </div>
      <div
        class="w-full text-white absolute bottom-2 left-0 px-6 z-10 flex flex-col gap-1"
      >
        <span class="text-xs">{{
          exhibitionNews?.addDate | day("YYYY年MM月DD日")
        }}</span>
        <span class="text-xs">{{ exhibitionNews?.descripton }}</span>
      </div>
    </div>
    <div class="flex flex-col gap-2 px-4">
      <div
        class="flex flex-col gap-1 pb-3"
        :style="{
          borderBottom: '1px',
          borderColor: '#e8e8e8',
          borderStyle: idx + 1 === recentNewsList?.length ? 'solid' : 'dashed',
        }"
        v-for="(item, idx) in recentNewsList"
        :key="item?.id"
        @click="() => handleNavigateToDetail(item?.id,item?.title)"
      >
        <div class="cursor-pointer text-primary font-normal">
          【{{ item?.addDate | day("YYYY年MM月DD") }}】
        </div>
        <div  style="color:#333333;opacity: 0.6;">{{ item?.title | truncate(40) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { array_ } from "../utils/index";
import mixins from "../hooks";
import imgURL from "../filters/imgURL";
import defaultImg from "@/assets/xinwen.png";

export default {
  name: "recentNews",
  mixins: [mixins],
  props: {
    info: {
      default: () => {
        return {};
      },
    },
  },
  data(){
    return{
      defaultImg:defaultImg,
    }
  },
  computed: {
    // 信息列表
    recentNewsList() {
      let item = this.info;
      let data = [];
      if (item.twoData && item.twoData.length > 0) {
        item.twoData.forEach((val) => {
          if (val.data && val.data.length > 0) {
            val.data = val.data.length > 4 ? val.data.splice(0, 4) : val.data;
          }
          if (val.data && val.data.length > 0) {
            data.push(...val.data);
          }
        });
      }
      data.sort(this.dateData("addDate", false));
      console.log(data,'data最新？')
      return data.length > 3 ? data.splice(0, 3) : data;
    },
    // 展示新闻
    exhibitionNews() {
      return this.recentNewsList?.[0];
    },
  },
  methods:{
    handleImageError(e){
      e.target.src = require('../../../assets/2.png')
    },
    dateData(property, bol) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (bol) {
          // 升序
          return Date.parse(value1) - Date.parse(value2);
        } else {
          // 降序
          return Date.parse(value2) - Date.parse(value1);
        }
      };
    },
    goMore(){
      console.log(this.info,'info')
      if(this.info.twoData&&this.info.twoData.length>0){
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: this.info.twoData[0].id },
        });
      }
    }
  }
};
</script>
<style scoped>
.oneTitleDiv {
  height: 70px;
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.oneTitle {
  width: 100%;
  background-size: 100% 100%;
  background: url("~@/assets/title.png") no-repeat;
  padding-left: 24px;
}
.pubTitle {
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  font-size: 18px;
  color: #176DAA;
  letter-spacing: 3.29px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-left: 14px;
}
.pubTitles {
  color: #176daa;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: left;
  margin-left: 14px;
  display: flex;
  align-items: center;
  margin-top: -4px;
}
.oneMore {
  cursor: pointer;
  position: absolute;
  right: 15px;
  bottom:0;
  height: 34px;
  width: 94px;
}
.recentNewsTitle {
  background: url("~@/assets/title.png") no-repeat;
  background-size: 100% 100%;
}
</style>
